import axios from "axios";

// API-ul textelor de informare (S4.4). Manager-only; tenantul vine din JWT.
// Oglindește `backend/ncrm/privacy/contracts/notice-input.js`; `de` din S5.0 (`GDPR-073`).
export const NOTICE_LOCALES = Object.freeze(["ro", "en", "ru", "de"]);
const PAGE_SIZE = 100;
const MAX_PAGES = 20;

// Toate versiunile unei perechi `purpose + locale`, cele mai noi primele.
export const fetchNotices = async ({ purposeId, locale }) => {
  const notices = [];
  for (let page = 0; page < MAX_PAGES; page += 1) {
    const { data } = await axios.get("/ncrm/privacy/configuration/notices", {
      params: { purpose_id: purposeId, locale, limit: PAGE_SIZE, offset: page * PAGE_SIZE },
    });
    const items = Array.isArray(data?.items) ? data.items : [];
    notices.push(...items);
    if (!data?.pagination?.has_more || !items.length) break;
  }
  return notices;
};

export const createNotice = async ({ purposeId, locale, consentText, noticeUrl }) => (await axios.post(
  "/ncrm/privacy/configuration/notices",
  { purpose_id: purposeId, locale, consent_text: consentText, notice_url: noticeUrl || null }
)).data;

export const updateNotice = async (id, { consentText, noticeUrl }) => (await axios.patch(
  `/ncrm/privacy/configuration/notices/${id}`,
  { consent_text: consentText, notice_url: noticeUrl || null }
)).data;

// `expectedHash` este hash-ul textului afișat: dacă ciorna s-a schimbat între timp,
// backendul răspunde `409 privacy_notice_changed` în loc să publice alt text.
export const publishNotice = async (id, expectedHash) => (await axios.post(
  `/ncrm/privacy/configuration/notices/${id}/publish`, { expected_hash: expectedHash }
)).data;
export const nextNoticeVersion = async (id) => (await axios.post(`/ncrm/privacy/configuration/notices/${id}/next-version`)).data;

// Starea perechii pentru acțiunile din secțiune: ciorna curentă, versiunea
// publicată și sursa pentru `Creează versiune nouă` (cea mai nouă non-ciornă).
export const noticePairState = (notices) => {
  const draft = notices.find((notice) => notice.status === "draft") || null;
  const published = notices.find((notice) => notice.status === "published") || null;
  const latestFinal = notices.find((notice) => notice.status !== "draft") || null;
  return { draft, published, nextSource: draft ? null : latestFinal };
};

// Numai un URL HTTPS se afișează ca link; oricare altul rămâne text.
export const safeNoticeUrl = (value) => {
  try {
    return new URL(value).protocol === "https:" ? value : null;
  } catch {
    return null;
  }
};
